import { ObjectParam } from '../shared/interface/generic-interface';
import { Injectable } from '@angular/core';
import { ApiConService } from '../shared/api-con.service';
import { MainHeaderTruckService } from '../main-header-truck/main-header-truck.service';
import { RouteService } from '../shared/route.service';
import { ControlStatusService } from '../shared/control-status.service';
import { Util } from '../shared/Util';
import { JsonReturn } from '../shared/interface/generic-interface';

@Injectable()
export class BoxListTruckService {

  public listTruckService: any;
  listTruckServiceSel: any;
  roteiroSelecionado: number;
  numeroBusca: number;

  constructor
  (
    private conService: ApiConService,
    private mainHeaderTruckService: MainHeaderTruckService,
    private routeService: RouteService,
    private controlStatus: ControlStatusService
  ) 
  {
    this.listTruckService = [];
  }

  async getListRouterTruck(objParam) 
  {
    try 
    {
      const response: JsonReturn = await this.conService.patchBodyRoteiro('DCroteiros', objParam);
      this.listTruckService = response.response;
    }
    catch (Error) 
    {
      console.log(Error);
    }
  }

  async getListRouterTruckPesquisa(numeroRoteiro: number) 
  {
    try 
    {
      const response: JsonReturn = await this.conService.patch('DCroteiros/' + numeroRoteiro);
      this.listTruckService = response.response;
    }
    catch (Error) 
    {
      console.log(Error);
    }
  }  

  async getListRouterTruckPorId(pedido) 
  {
    try 
    {
      let response : JsonReturn;
      if(pedido){
        response = await this.conService.patch('DCroteiros/pedido/' + this.roteiroSelecionado);
        this.roteiroSelecionado = response.response ? response.response[0].roteiro : null;
      }else {
        response = await this.conService.patch('DCroteiros/' + this.roteiroSelecionado);
      }
      
      if(response.response && response.response.length > 0){
        this.listTruckServiceSel = response.response;

        this.routeService.exibeAlerta = true;
        
        if (this.listTruckServiceSel[0].problemas == 0) 
        {
          this.routeService.exibeAlerta = false;
        }
  
        this.mainHeaderTruckService.veiculo = this.listTruckServiceSel[0].veiculo;
        this.mainHeaderTruckService.nomeMotorista = this.listTruckServiceSel[0].nome_motorista;
        this.mainHeaderTruckService.nomeCompletoMotorista = this.listTruckServiceSel[0].nome_motorista;
        this.mainHeaderTruckService.contatoMotorista = this.listTruckServiceSel[0].ContatoMotorista;
        this.mainHeaderTruckService.porcBateria = 0;
  
        return response.response;
      }else{
        return null;
      } 
    }
    catch (Error) 
    {
      this.controlStatus.msgErroBusca = "Ocorreu um erro ao buscar o roteiro.";
      console.log(Error);
    }
  }

  async getTempoTotalRtoeiro(idRoteiro: any): Promise<JsonReturn>{  
    return await this.conService.patch(`DCAtividadeMotorista/tempoTotalRoteiro/${idRoteiro}`)
  }

  async placasVeiculosDisponiveis(){
    try 
    {
      const response: JsonReturn = await this.conService.patch('DCroteiros/placasVeiculosDisponiveis');
      return response.response;
    }
    catch (Error) 
    {   
      console.log(Error);
      return [];
    }
  }

  async motoristasDisponiveis(){
    try 
    {
      const response: JsonReturn = await this.conService.patch('DCroteiros/motoristasDisponiveis');
      return response.response;
    }
    catch (Error) 
    {   
      console.log(Error);
      return [];
    }
  }

  async atulizaPlacasVeiculosDisponiveis( idRoteiro, placa){
    try 
    {
      return await this.conService.patch(`DCroteiros/placasVeiculosDisponiveis/${idRoteiro}/${placa}`);
    }
    catch (Error) 
    {
      console.log("Erro ao atualizar a placa");
    }
  }

  async atulizaNomeMotoristaDisponiveis( idRoteiro, nomeMotorista){
    try 
    {
      return await this.conService.patch(`DCroteiros/motoristasDisponiveis/${idRoteiro}/${nomeMotorista}`);
    }
    catch (Error) 
    {
      console.log("Erro ao atualizar nome do motorista");
    }
  }

  async desconectarVeiculo(idRoteiro){
    try 
    {
      return await this.conService.patch(`DCroteiros/desconectarVeiculo/${idRoteiro}`);
    }
    catch (Error) 
    {
      console.log("Erro ao atualizar a desconectar veículo");
    }
  }

  async getFotoOdometro(numeroRoteiro, situacao){
    let response: JsonReturn = await this.conService.patch(`DCroteiros/odometro/${numeroRoteiro}/${situacao}`);
    return  Util.decompress(response.response);;
  }
}
